import { academic } from './academic/academic';
import { auth } from './auth/auth';
import { coupons } from './coupons/coupons';
import { extraFees } from './extraFees/extraFees';
import { offers } from './offers/offers';
import { payments } from './payments/payments';
import { polling } from './polling/polling';
import { trackingPage } from './trackingPage/trackingPage';
import { users } from './users/users';

const payex = {
  auth,
  coupons,
  extraFees,
  offers,
  payments,
  polling,
  trackingPage,
  users,
  academic,
};

type PayexService = typeof payex;

export { type PayexService, payex };
